import axios from "axios";
import { tokenManager } from "../utils/tokenManager";

const RAG_API_URL =
  window.env.REACT_APP_RAG_API_URL || "http://localhost:8002/api/v1";

const apiInstance = axios.create({
  baseURL: RAG_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

tokenManager.setupInterceptors(apiInstance);

export const customizationApi = {
  getSupportedLanguages: () => {
    return apiInstance.get("/customization/language/supported");
  },

  getDefaultLanguage: () => {
    return apiInstance.get("/customization/language/default");
  },

  getDefaultTheme: () => {
    return apiInstance.get("/customization/theme/default");
  },

  getThemes: () => {
    return apiInstance.get("/customization/theme/");
  },

  getTheme: (orgId) => {
    return apiInstance.get(`/customization/theme/${orgId}`);
  },

  createTheme: (orgId, data) => {
    return apiInstance.post(`/customization/theme/${orgId}`, data);
  },

  updateTheme: (orgId, data) => {
    return apiInstance.put(`/customization/theme/${orgId}`, data);
  },

  patchTheme: (orgId, data) => {
    return apiInstance.patch(`/customization/theme/${orgId}`, data);
  },

  updateLanguage: (orgId, defaultLanguage) => {
    return apiInstance.put(`/customization/language/${orgId}`, {
      default_language: defaultLanguage,
    });
  },

  deleteTheme: (orgId, mode) => {
    return apiInstance.delete(`/customization/theme/${orgId}?mode=${mode}`);
  },

  uploadThemeLogo: (orgId, file, mode, type) => {
    const formData = new FormData();
    const logoTypes = {
      logo: "compact",
      wideLogo: "wide",
      favicon: "favicon",
    };

    formData.append("file", file);
    formData.append("theme_mode", mode);
    formData.append("logo_type", logoTypes[type]);

    return apiInstance.post(
      `/customization/theme/${orgId}/logo/upload`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      },
    );
  },

  previewTheme: (orgId, data) => {
    return apiInstance.post(`/customization/theme/${orgId}/preview`, data);
  },
};
